import { PayloadAction, createSlice } from '@reduxjs/toolkit';

// preparando: o servidor monta o arquivo · iniciado: entregue ao navegador · baixando: só no
// caminho antigo (arquivo passa pela página, com % real) · erro: falhou, com mensagem
export type FileDownloadPhase = 'preparando' | 'iniciado' | 'baixando' | 'erro';

export interface FileDownload {
  id: string,
  nome: string,
  fase: FileDownloadPhase,
  tamanhoBytes: number | null,
  progresso: number | null,
  mensagem: string | null,
}

export interface FileDownloadsState {
  download: FileDownload | null,
}

const initialState: FileDownloadsState = {
  download: null,
};

// Um download por vez. Toda ação leva o `id`: resposta atrasada de um download antigo (o usuário
// clicou de novo, ou fechou o card) não pode sobrescrever o atual.
const isCurrent = (state: FileDownloadsState, id: string) => state.download?.id === id;

export const fileDownloadsSlice = createSlice({
  name: 'fileDownloads',
  initialState,
  reducers: {
    downloadPreparing: (
      state,
      action: PayloadAction<{ id: string, nome: string, mensagem?: string }>,
    ) => {
      const { id, nome, mensagem } = action.payload;
      state.download = {
        id,
        nome,
        fase: 'preparando',
        tamanhoBytes: null,
        progresso: null,
        mensagem: mensagem ?? null,
      };
    },
    downloadProgressed: (
      state,
      action: PayloadAction<{ id: string, progresso: number | null, tamanhoBytes?: number }>,
    ) => {
      const { id, progresso, tamanhoBytes } = action.payload;
      if (!state.download || !isCurrent(state, id)) return;
      state.download.fase = 'baixando';
      state.download.progresso = progresso;
      state.download.mensagem = null;
      if (tamanhoBytes !== undefined) state.download.tamanhoBytes = tamanhoBytes;
    },
    downloadStarted: (
      state,
      action: PayloadAction<{ id: string, tamanhoBytes: number | null, mensagem?: string }>,
    ) => {
      const { id, tamanhoBytes, mensagem } = action.payload;
      if (!state.download || !isCurrent(state, id)) return;
      state.download.fase = 'iniciado';
      state.download.tamanhoBytes = tamanhoBytes;
      state.download.progresso = null;
      state.download.mensagem = mensagem ?? null;
    },
    downloadFailed: (
      state,
      action: PayloadAction<{ id: string, mensagem: string }>,
    ) => {
      const { id, mensagem } = action.payload;
      if (!state.download || !isCurrent(state, id)) return;
      state.download.fase = 'erro';
      state.download.progresso = null;
      state.download.mensagem = mensagem;
    },
    downloadDismissed: (state, action: PayloadAction<string>) => {
      if (isCurrent(state, action.payload)) state.download = null;
    },
  },
});

/* eslint-disable @typescript-eslint/no-explicit-any */
export const selectFileDownload = (state: any): FileDownload | null => state.fileDownloads.download;
/* eslint-enable @typescript-eslint/no-explicit-any */

export const {
  downloadPreparing,
  downloadProgressed,
  downloadStarted,
  downloadFailed,
  downloadDismissed,
} = fileDownloadsSlice.actions;

export default fileDownloadsSlice.reducer;
